export default "__VITE_ASSET__c39cf8a9__$_?component__"